import {SyncfusionComponentTranslation} from '../../syncfusion-component-types';
import {
  Calendar,
  ColorPicker,
  DatePicker,
  Dates,
  DateTimePicker,
  DocumentEditor,
  DocumentEditorContainer,
  Dropdowns,
  Grid,
  Pager,
  RecurrenceEditor,
  Schedule,
} from '../../syncfusion-component-names';
import {DocumentEditorContainerFrenchTranslation} from './document-editor-container-french-translation';
import {GridFrenchTranslation} from './grid-french';
import {DocumentEditorFrenchTranslation} from './document-editor-french-translation';
import {SyncfusionOriginalFrenchTranslation} from './syncfusion-original-french-translation';

export const FrenchTranslation: SyncfusionComponentTranslation = {
  [DocumentEditorContainer]: Object.assign(
    {},
    SyncfusionOriginalFrenchTranslation.documenteditorcontainer,
    DocumentEditorContainerFrenchTranslation,
  ),
  [DocumentEditor]: Object.assign(
    {},
    SyncfusionOriginalFrenchTranslation.documenteditor,
    DocumentEditorFrenchTranslation,
  ),
  [ColorPicker]: SyncfusionOriginalFrenchTranslation.colorpicker,
  [Pager]: SyncfusionOriginalFrenchTranslation.pager,
  [Grid]: Object.assign({}, SyncfusionOriginalFrenchTranslation.grid, GridFrenchTranslation),
  [Dropdowns]: SyncfusionOriginalFrenchTranslation.dropdowns,
  [DatePicker]: SyncfusionOriginalFrenchTranslation.datepicker,
  [DateTimePicker]: SyncfusionOriginalFrenchTranslation.datetimepicker,
  [Schedule]: SyncfusionOriginalFrenchTranslation.schedule,
  [Calendar]: SyncfusionOriginalFrenchTranslation.calendar,
  [RecurrenceEditor]: SyncfusionOriginalFrenchTranslation.recurrenceeditor,
  [Dates]: SyncfusionOriginalFrenchTranslation.dates,
};

export const FrenchOperatorsTranslation = {
  Equal: 'égal',
  ['Not Equal']: 'différent de',
  ['Starts With']: 'commence par',
  ['Ends With']: 'finit par',
  ['Contains']: 'contient',
};
